var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgClockFrame = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.14043 0 0 3.14009 0 7C0 10.8599 3.14043 14 7 14C10.8596 14 14 10.8599 14 7C14 3.14009 10.8596 0 7 0ZM10.3599 9.52007C10.2225 9.70327 10.0126 9.8 9.79932 9.8C9.65303 9.8 9.50605 9.75454 9.38027 9.65986L6.58027 7.55986C6.40391 7.42793 6.3 7.22046 6.3 7V2.09299C6.3 1.70642 6.61309 1.39299 7 1.39299C7.38691 1.39299 7.7 1.70642 7.7 2.09299V6.65L10.2197 8.54014C10.5294 8.77187 10.5923 9.21074 10.3599 9.52007Z",
    fill: "#E7B92A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClockFrame, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/clock-frame.1463981f.svg";
export { ForwardRef as ReactComponent };